
import { Component, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';

import { LoadingSpinnerComponent } from '../loading-spinner.component/loading-spinner.component';

@Component({
  selector: 'app-loading-card',
  standalone: true,
  imports: [MatCardModule, AgrI18nSharedModule, LoadingSpinnerComponent],
  template: `
    <mat-card class="loading-card">
      <mat-card-content>
        <div class="loading-container">
          <app-loading-spinner [size]="spinnerSize()"></app-loading-spinner>
          <span>{{ loadingText() | translate }}</span>
        </div>
      </mat-card-content>
    </mat-card>
  `,
  styleUrls: ['./loading-card.component.scss'],
})
export class LoadingCardComponent {
  /**
   * The translation key for the loading text
   * @default 'BFP.UI.Loading'
   */
  loadingText = input<string>('BFP.UI.Loading');

  /**
   * The diameter of the spinner in pixels
   * @default 40
   */
  spinnerSize = input<number>(40);
}
